import React from 'react';
export default function HeavyWaves({ children }) {
  const Wave = ({ className }) => {
    return (
      <svg
        className={className}
        preserveAspectRatio="none"
        width="110%"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
      >
        <path d="M0,96L13.3,122.7C26.7,149,53,203,80,197.3C106.7,192,133,128,160,96C186.7,64,213,64,240,90.7C266.7,117,293,171,320,176C346.7,181,373,139,400,117.3C426.7,96,453,96,480,112C506.7,128,533,160,560,149.3C586.7,139,613,85,640,53.3C666.7,21,693,11,720,58.7C746.7,107,773,213,800,234.7C826.7,256,853,192,880,165.3C906.7,139,933,149,960,144C986.7,139,1013,117,1040,122.7C1066.7,128,1093,160,1120,149.3C1146.7,139,1173,85,1200,96C1226.7,107,1253,181,1280,202.7C1306.7,224,1333,192,1360,154.7C1386.7,117,1413,75,1427,53.3L1440,32L1440,320L1426.7,320C1413.3,320,1387,320,1360,320C1333.3,320,1307,320,1280,320C1253.3,320,1227,320,1200,320C1173.3,320,1147,320,1120,320C1093.3,320,1067,320,1040,320C1013.3,320,987,320,960,320C933.3,320,907,320,880,320C853.3,320,827,320,800,320C773.3,320,747,320,720,320C693.3,320,667,320,640,320C613.3,320,587,320,560,320C533.3,320,507,320,480,320C453.3,320,427,320,400,320C373.3,320,347,320,320,320C293.3,320,267,320,240,320C213.3,320,187,320,160,320C133.3,320,107,320,80,320C53.3,320,27,320,13,320L0,320Z"></path>
      </svg>
    );
  };
  return (
    <div className="w-full h-[400px] overflow-hidden flex flex-col justify-center  pb-3 bg-white">
      <Wave className="fill-primary-600" />
      <div className="bg-primary-600 h-[250px] w-full flex flex-col justify-center items-center">
        {children}
      </div>
      <Wave className="rotate-180 fill-primary-600 mt-[-1px]" />
    </div>
  );
}
